import _memoize from 'lodash/memoize';
import { PRIMARY, makeThemeColor, DEFAULT_MODE } from '@tornado-rdk/theme';
import { Lightning } from '@lightningjs/sdk';
import { getScreenSize } from '../../../utils/sizes';
import { BORDER_WIDTH } from '../../../utils/focus';
import { TRANSPARENT } from '../../../utils/colors';

export const defaultContext = { screenSize: getScreenSize(), colorMode: DEFAULT_MODE };

export const BORDER_COLOR = makeThemeColor(PRIMARY);

export { BORDER_WIDTH };

export const getBorderTexture = _memoize(
  ({ screenSize, colorMode }, radius) => {
    const diameter = radius * 2 + BORDER_WIDTH[screenSize] * 2;

    return Lightning.Tools.getRoundRect(
      diameter,
      diameter,
      radius + BORDER_WIDTH[screenSize],
      // NOTE: while border width should be equal to 3px, we adding an extra pixel to ensure there will be no gap between image and border
      BORDER_WIDTH[screenSize] + 1,
      BORDER_COLOR[colorMode],
      true,
      TRANSPARENT,
    );
  },
  ({ screenSize, colorMode }, radius) => `${screenSize}_${colorMode}_${radius}`,
);
